import { ListTransactionPage } from "@containers";
import { useEffect } from "react";
import { Strings } from "@constant";
import { useParams } from "react-router-dom";

export const ListTransaction = () => {
  let params: any = useParams();

  useEffect(() => {
    document.title = Strings.pageTitle("Transaction");
  });

  return (
    <>
      <ListTransactionPage id={params.id} />
    </>
  );
};
